import Alpine from "alpinejs";
import persist from "@alpinejs/persist";
import money from "alpinejs-money";
import { CartStore } from "./store"; // this is factored out because alpine makes testing hard

const productStorageKey = "ccart";

// Cart object derived from https://github.com/Drozerah/e-commerce-alpine-store-front

document.addEventListener("alpine:init", () => {
  Alpine.store(
    "_",
    new CartStore(productStorageKey, (value, key) => {
      return Alpine.$persist(value).as(key);
    }),
  );

  Alpine.effect(() => {
    // add/remove class name of noScroll to body according to slideout state
    const store: CartStore = Alpine.store("_") as CartStore;
    const isCartDialog = store.isCartDialog;
    const body = document.body;
    isCartDialog === true
      ? body.classList.add("noScroll")
      : body.classList.remove("noScroll");
  });
});

declare global {
  interface Window {
    Alpine: typeof Alpine;
  }
}

window.Alpine = Alpine;

Alpine.plugin(persist);
Alpine.plugin(money);
Alpine.start();
